import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { UpdateExpiryCardForm } from '@/components/UpdateExpiryCardForm';
import { useRootNavigation } from '@/hooks/use-root-navigation';
import { DepositExpiryUpdateNavigationProp } from '@/navigation/deposit/types';
import { DepositStackParamList } from '@/navigation/types';

import { PaymentMethodTypes } from '../const';

type DepositExpiryUpdateProps = NativeStackScreenProps<DepositStackParamList, 'DepositExpiryUpdate'>;

export const DepositExpiryUpdate = ({ route }: DepositExpiryUpdateProps) => {
    const navigation = useNavigation<DepositExpiryUpdateNavigationProp>();
    const rootNavigation = useRootNavigation();
    const { t } = useTranslation(['transactions', 'wallet', 'common']);

    const secondaryButtonLabel = t('deposit_with_payment_name', { paymentMethodTypeName: 'Paypal' });

    const onSuccessUpdateCard = () => {
        navigation.navigate('VerifyingDebitDeposit', { ...route.params });
    };

    const onErrorUpdateCard = () => {
        navigation.navigate('ErrorModal', {
            title: t('wallet:update_expiry_card_error_title'),
            subtitle: t('wallet:update_expiry_card_error_subtitle'),
            primaryButton: t('common:review_information'),
            showSecondaryButton: true,
            secondaryButton: secondaryButtonLabel,
            handleSecondaryButtonPress: () => {
                // from the root, so the error modal closes and the webview opens in the deposit stack under it
                rootNavigation.navigate(
                    'DepositStack',
                    { screen: 'DepositMethodWebViewModal', params: paypalWebViewParams },
                    { pop: true }
                );
            },
            closeIconMode: 'close',
        });
    };

    const paypalWebViewParams = {
        ...route.params,
        selectedPaymentMethodType: PaymentMethodTypes.PaysafePaypal,
    };

    const onPressSecondaryButton = () => {
        navigation.navigate('DepositMethodWebViewModal', paypalWebViewParams);
    };

    const paymentTypeId = route.params.payment_type_id ?? '';

    return (
        <UpdateExpiryCardForm
            {...{ paymentTypeId, onSuccessUpdateCard, onErrorUpdateCard, onPressSecondaryButton, secondaryButtonLabel }}
        />
    );
};
